import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MemberPaths } from "src/app/constants/routes";
import { PassthroughBearTokenPayload } from "src/app/models/auth";
import { MemberSession } from "src/app/models/member";
import { AuthService } from "src/app/services/auth.service";

@Component({
    selector: 'mwp-passthrough',
    templateUrl: './passthrough.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PassthroughComponent implements OnInit {
    id: string;

    constructor(
        private route: ActivatedRoute,
        private authService: AuthService,
        private router: Router,

    ) { }

    ngOnInit(): void {
        this.route.queryParams.subscribe((params: Params) => {
            this.id = params['id'];
            const payload = new PassthroughBearTokenPayload();
            payload.id = this.id;
            this.authService.passthroughLogin(payload).subscribe((response: MemberSession) => {
                this.router.navigateByUrl(MemberPaths.Dashboard);
            });
        });
    };
};


